import React, {useEffect, useState} from "react";
import './App.css';
import logoInk from "./ledger/logos/quantaprice-ledger-ink.svg";

const redirectDirectlyIfOnlyOneIdp = true;

const App: React.FC = () => {
    const [idpDefinition, setIdpDefinition] = useState<any>();
    useEffect(() => {
        let clientId = new URLSearchParams(window.location.search).get("client_id");
        // client_id may be a URL (third-party MCP client); those need the tenant's `resource`.
        let resource = new URLSearchParams(window.location.search).get("resource");
        fetch(`/api/idp/${encodeURIComponent(clientId || "default")}${resource ? `?resource=${encodeURIComponent(resource)}` : ""}`)
            .then(res => res.json())
            .then(res => {
                // Silent renewal (hidden iframe, prompt=none): never show UI. oidc-proxy answers with
                // either a fresh code or error=login_required for the redirect_uri.
                if (new URLSearchParams(window.location.search).get("prompt") === "none") {
                    createLoginSession(res?.idps?.[0] ?? "directory")
                        .then(loginSession => {
                            window.location.href = loginSession.url;
                        });
                    return;
                }
                if (redirectDirectlyIfOnlyOneIdp) {
                    if (res?.idps?.length === 1) {
                        createLoginSession(res.idps[0])
                            .then(loginSession => {
                                window.location.href = loginSession.url;
                            })
                    } else {
                        setIdpDefinition(res);
                        if (res?.theme?.style?.css) {
                            let style = document.getElementById("dynamic-style");
                            if (!style) {
                                style = document.createElement('style');
                                style.id = "dynamic-style";
                                document.head.appendChild(style);
                            }
                            style.innerHTML = res.theme.style.css;
                        }
                        if (res?.theme?.style?.favicon) {
                            let link : any = document.querySelector("link[rel~='icon']");
                            if (!link) {
                                link = document.createElement('link');
                                link["rel"] = 'icon';
                                document.head.appendChild(link);
                            }
                            link.href = res?.theme?.style?.favicon
                        }

                        // let cssItem = document.styleSheets.item(0);
                        // if (res?.theme?.style?.css && cssItem) {
                        //     cssItem.insertRule(res.theme.style.css);
                        // }
                    }
                } else {
                    setIdpDefinition(res);
                    if (res?.theme?.style?.css) {
                        let style = document.getElementById("dynamic-style");
                        if (!style) {
                            style = document.createElement('style');
                            style.id = "dynamic-style";
                            document.head.appendChild(style);
                        }
                        style.innerHTML = res.theme.style.css;
                    }
                    if (res?.theme?.style?.favicon) {
                        let link:any = document.querySelector("link[rel~='icon']");
                        if (!link) {
                            link = document.createElement('link');
                            link.rel = 'icon';
                            document.head.appendChild(link);
                        }
                        link.href = res?.theme?.style?.favicon
                    }
                }
            });
    }, []);


    const loginTargets: any = {
        azuread: "Azure",
        google: "Google",
        github: "Github",
        directory: "Quantaprice"
    }

    const createLoginSession = async (idp: any) => {
        let returnUrl = new URLSearchParams(window.location.search).get("redirect_uri");
        let clientId = new URLSearchParams(window.location.search).get("client_id");
        let state = new URLSearchParams(window.location.search).get("state");
        let prompt = new URLSearchParams(window.location.search).get("prompt");
        let params = [];
        if (returnUrl) {
            params.push(`redirect_uri=${encodeURIComponent(returnUrl)}`)
        }
        if (state) {
            params.push(`state=${state}`)
        }
        if (prompt) {
            params.push(`prompt=${encodeURIComponent(prompt)}`)
        }
        for (const passthrough of ["code_challenge", "code_challenge_method", "resource"]) {
            const value = new URLSearchParams(window.location.search).get(passthrough);
            if (value) {
                params.push(`${passthrough}=${encodeURIComponent(value)}`)
            }
        }
        let url = `/api/idp/loginSession/${encodeURIComponent(String(clientId))}/${idp}?${params.join("&")}`;
        return await fetch(url).then(res => res.json());
    };

    const login = async (idp: any) => {
        let loginSession = await createLoginSession(idp);
        console.log("loginSession", loginSession);
        window.location.href = loginSession.url;
    }




    if (!idpDefinition) {
        return null;
    }

    return (
        <main className="ql-auth oidcp-login-wrapper">
            <div className="oidcp-logo-wrapper">
                <img className="ql-auth-logo oidcp-logo" src={logoInk} alt="Quantaprice"/>
            </div>
            <section className="ql-auth-card oidcp-provider-selector">
                <h1 className="ql-auth-title oidcp-provider-selector-text">Sign in</h1>
                <p className="ql-auth-subtitle">to the <span className="ql-mono">{idpDefinition?.name}</span> tenant</p>
                <div className="ql-auth-body oidcp-provider-selector-list">
                    {idpDefinition?.idps && idpDefinition.idps.map((idp: any) => (
                        <button key={idp} type="button"
                                className="ql-btn ql-btn-block oidcp-provider-selector-button"
                                onClick={login.bind(this, idp)}>
                            <img className="oidcp-provider-icon" src={`${idp}.svg`} alt=""/>
                            Continue with {loginTargets[idp]}
                        </button>
                    ))}
                </div>
            </section>
        </main>
    );
}

export default App;
